import { ClientInsuranceModel } from "@app/insurance/models";
import { DashboardModel, RoleModel } from "../user";
import { ClientRoleModel } from "../client";

interface ClientBaseModel {
  bulkUploadLimitHourWindow: number;
  bulkUploadRecordLimit: number;
  clientId: number;
  crossProjectDatabaseConnectionId: number;
  dashboards: Array<DashboardModel>;
  databaseConnectionId: number;
  dateDeactivated: string;
  disableAccessCacheReads: boolean;
  disableAccessCacheWrites: boolean;
  domains: Array<{ domain: string }>;
  enterpriseComplianceDashboardDatabaseConnectionId: number;
  holdSoftwareRelease?: boolean;
  isActive: boolean;
  isQuestInternal: boolean;
  authorizedInsurances: Array<ClientInsuranceModel>;
  logoUrl: string;
  name: string;
  networkServicingProviderReportLimit: number;
  outreachClientXid: string;
  outreachMetricsActivationDate: string;
  pciDashboardDatabaseConnectionId: number;
  prospectMarketServicingProviderReportLimit: number;
  roles: Array<ClientRoleModel>;
  sfAccountId: string;
  storageConnectionString: string;
  storageContainerName: string;

  resourceAdminGuestLoginsAllowed?: boolean;
  questViewerGuestLoginsAllowed?: boolean;
  restrictedUserCreationEnabled?: boolean;
  networkBenchmarkingDataRights: ClientNetworkBenchmarkingDataRightsEnum;
  networkBenchmarkingDataSource: boolean;
}

interface Client extends ClientBaseModel {
  defaultUserRoles: Array<ClientRoleModel>;
  questViewerGuestUserRoles: Array<ClientRoleModel>;
  resourceAdminGuestUserRoles: Array<ClientRoleModel>;
  softwareReleases: Array<ClientSoftwareReleaseModel>;
}


interface ClientToApi extends ClientBaseModel {
  addedSoftwareReleaseIds: number[];
  removedSoftwareReleaseIds: number[];
}

interface NewClientDefaults {
  defaultStorageConnectionString:string;
  defaultDatabaseConnectionId: number;
  defaultRoles: Array<RoleModel>;
  defaultDashboards: Array<DashboardModel>;
}

interface ClientSoftwareReleaseModel {
  softwareReleaseId: number;
  productSuiteId: number;
  releaseYear: number;
  releaseQuarter: number;
  dateReleased: Date;
  releasedToClient: boolean;
}

interface ClientListItem {
  clientId: number;
  name: string;
}

enum ClientNetworkBenchmarkingDataRightsEnum {
  NotFound = "Not Found",
  FullExplicitRights = "Full Explicit Rights",
  NoExplicitRights = "No Explicit Rights",
  CustomRightsBlindSource = "Custom Rights - Blind Source",
  CustomRightsOther = "Custom Rights - Other",
}

export { Client, ClientListItem, ClientNetworkBenchmarkingDataRightsEnum, ClientSoftwareReleaseModel, ClientToApi, NewClientDefaults };
